import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import globalAxios from "../../globalAxios";

export const fetchPendingUploads = createAsyncThunk(
	"pendingUploads/fetchPendingUploads",
	async (_, { rejectWithValue }) => {
		try {
			const response = await globalAxios.get("/pending-uploads");
			return response.data;
		} catch (err) {
			console.error("Error fetching pending uploads", err);
			return rejectWithValue("Failed to load pending uploads.");
		}
	}
);

export interface PendingUpload {
	id: number;
	session_id?: number;
	created_at: string;
	[key: string]: any;
}

interface PendingUploadsState {
	pendingUploads: PendingUpload[];
	loading: boolean;
	error: string | null;
}

const initialState: PendingUploadsState = {
	pendingUploads: [],
	loading: false,
	error: null,
};

const pendingUploadsSlice = createSlice({
	name: "pendingUploads",
	initialState,
	reducers: {
		setPendingUploads(state, action: PayloadAction<PendingUpload[]>) {
			state.pendingUploads = action.payload;
			state.loading = false;
			state.error = null;
		},
		addPendingUpload(state, action: PayloadAction<PendingUpload>) {
			state.pendingUploads.unshift(action.payload);
		},
		removePendingUpload(state, action: PayloadAction<number>) {
			state.pendingUploads = state.pendingUploads.filter(
				(upload) => upload.id !== action.payload
			);
		},
		setPendingUploadsLoading(state, action: PayloadAction<boolean>) {
			state.loading = action.payload;
		},
		setPendingUploadsError(state, action: PayloadAction<string | null>) {
			state.error = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchPendingUploads.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchPendingUploads.fulfilled, (state, action) => {
				state.pendingUploads = action.payload || [];
				state.loading = false;
			})
			.addCase(fetchPendingUploads.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as string;
			});
	},
});

export const {
	setPendingUploads,
	addPendingUpload,
	removePendingUpload,
	setPendingUploadsLoading,
	setPendingUploadsError,
} = pendingUploadsSlice.actions;

export default pendingUploadsSlice.reducer;
